import { useQuery, UseQueryResult } from 'react-query';
import { PublicTenantInfo } from './model';
import { restClient } from '../../../App';
import { PublicTenantResponse } from '../interface/apiModels';
import { convertPlayerDTOs } from '../player/playerConverter';
import { convertGames } from '../games/gameConverter';
import { ApiException } from '../interface/ApiException';
import { ApiError } from '../interface/ApiError';

export const PUBLIC_ALL_PLAYERS_KEY = 'public/players';

const convertPublicTenantInfoResponse = (response: PublicTenantResponse): PublicTenantInfo => {
  return {
    players: convertPlayerDTOs(response.players),
    tenantName: response.tenantName,
    openGames: convertGames(response.openGames),
    results: convertGames(response.results),
  };
};

const fetchPublicTenantInfo = async (key: string): Promise<PublicTenantInfo> => {
  const response = await restClient.getPublicTenantInfo({ param: key });
  return convertPublicTenantInfoResponse(response);
};

export const usePublicTenantInfo = (
  key: string
): UseQueryResult<PublicTenantInfo | undefined, ApiException<ApiError>> => {
  return useQuery([PUBLIC_ALL_PLAYERS_KEY, key], () => fetchPublicTenantInfo(key));
};
